module.exports = __webpack_public_path__ + "static/media/logo-h-blanco.6891c809.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria/img/logo-h-blanco.png
 ** module id = 18
 ** module chunks = 0
 **/